// Module
var code = `<div class="card">
	<div class="card-header">
		<span class="h4 card-title">Configure Scenes</span>
	</div>
	<div class="card-body">
		<ul class="list-unstyled list-striped">
			<li ng-repeat="scene in \$ctrl.Scenes track by scene.id" style="padding: 10px; min-height: 32px" class="d-flex justify-content-between align-items-center">
				<div>
					<i ng-class="{'fa-arrows-up-down': scene.orientation === 'p', 'fa-arrows-left-right': scene.orientation === 'l'}" class="fas fa-fw"></i>
					<span ng-style="{'color': scene.color}"> {{scene.name}}</span>
				</div>
				<div>
					<i ng-if="\$ctrl.clientId === scene.clientId" class="fa fa-star"></i>&nbsp;
					<button type="button" ui-sref="manager.scene-edit({id: scene.id})" class="btn btn-outline-primary btn-sm">
						<i class="fas fa-pencil"></i>
					</button>
				</div>
			</li>
		</ul>
		<p style="margin-top: 10px;">
			<div class="d-grid">
				<button type="button" ui-sref="manager.scene-new" class="btn btn-success">
					<i class="fas fa-plus-circle"></i>
					<span> Add Scene</span>
				</button>
			</div>
		</p>
		<p class="notify-center">
			<span>This browser's id (click to copy to clipboard):</span><br/>
			<span class="clickableSpan" ng-class="\$ctrl.copySuccess ? 'active' : 'inactive'" ng-click="\$ctrl.copyToClipboard()" title="Click to copy">{{\$ctrl.clientId}}
				<i ng-if="!\$ctrl.copySuccess" class="fas fa-clipboard" style="margin-left: 5px;"></i>
				<i ng-if="\$ctrl.copySuccess" class="fas fa-check" style="margin-left: 5px; color: green"></i>
			</span>
		</p>
	</div>
</div>`;
// Exports
export default code;